import { Outlet, Navigate } from 'react-router';
import { useAuth } from '../providers/AuthContext.tsx';
import React from 'react';

const ProtectedRoute = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>; //TODO: Make a Loading screen
  }

  return user ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
